import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Characters from './pages/Characters';
import Elements from './pages/Elements';
import Pillars from './pages/Pillars';
import PillarHierarchy from './components/PillarHierarchy';
import imageLoader from './utils/optimizedImageLoader';
import './App.css';

function App() {
  console.log('🚀 App component rendering');
  
  // Initialize optimized image loader
  useEffect(() => {
    imageLoader.preloadCriticalImages();
  }, []);
  
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="main">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route 
                path="/" 
                element={
                  <ProtectedRoute>
                    <Overview />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/characters" 
                element={
                  <ProtectedRoute>
                    <Characters />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/elements" 
                element={
                  <ProtectedRoute>
                    <Elements />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/pillars" 
                element={
                  <ProtectedRoute>
                    <Pillars />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/pillars/hierarchy/:l1Name" 
                element={
                  <ProtectedRoute>
                    <PillarHierarchy />
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
